import { render, staticRenderFns } from "./CommentTypeSlidebar.vue?vue&type=template&id=32f7bb9a"
import script from "./CommentTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./CommentTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports